import { render, staticRenderFns } from "./PageIndex.vue?vue&type=template&id=abdccc3c"
import script from "./PageIndex.vue?vue&type=script&lang=js"
export * from "./PageIndex.vue?vue&type=script&lang=js"
import style0 from "./PageIndex.vue?vue&type=style&index=0&id=abdccc3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports